import styled from 'styled-components';

import shouldForwardProp from 'configs/shouldForwardProp';
import { focusRingDecl } from 'theme/mixins';

export const StyledLabel = styled.label.withConfig({ shouldForwardProp })<{ disabled?: boolean }>`
  display: inline-flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.s}px;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};
  color: ${({ theme }) => theme.colors.textPrimary};
  font-family: ${({ theme }) => theme.fonts.regular};
  font-size: ${({ theme }) => theme.fontSizes.s}px;
  user-select: none;
`;

export const StyledTrack = styled.span.withConfig({ shouldForwardProp })<{ checked: boolean }>`
  position: relative;
  display: inline-block;
  width: 38px;
  height: 22px;
  flex-shrink: 0;
  border-radius: ${({ theme }) => theme.borderRadius.pill}px;
  background-color: ${({ theme, checked }) => (checked ? theme.colors.primary : theme.colors.borderStrong)};
  transition: background-color 0.15s ease;
`;

export const StyledKnob = styled.span.withConfig({ shouldForwardProp })<{ checked: boolean }>`
  position: absolute;
  top: 2px;
  left: 2px;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background-color: ${({ theme }) => theme.colors.textPrimary};
  box-shadow: ${({ theme }) => theme.shadow.knob};
  transform: translateX(${({ checked }) => (checked ? '16px' : '0')});
  transition: transform 0.15s ease;
`;

export const StyledNativeInput = styled.input`
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;

  /* The real input is hidden, so focus rings the track it controls. */
  &:focus-visible + ${StyledTrack} {
    ${focusRingDecl}
  }
`;
